<template>
  <div class="search-results__wrapper">
    <template v-if="products.length > 0">
      <ProductItem
        v-for="(product, index) in products"
        :key="product.handle"
        :product="product"
        :index="index"
        :is-search-result="true"
      />
    </template>
    <!-- Keep static content if no products loaded yet -->
    <slot v-else />
  </div>
</template>

<script>
import { mapActions } from 'pinia'
import { useCollectionStore } from '../pinia/CollectionStore'
import ProductItem from './product-item'

export default {
  name: 'SearchResults',
  components: {
    ProductItem
  },
  data() {
    return {
      products: [],
      staticContentCleared: false
    }
  },
  mounted() {
    // Get search results from window.theme
    if (window.theme && window.theme.searchResults) {
      this.products = window.theme.searchResults

      // Clear the static content once Vue takes over
      if (!this.staticContentCleared && this.$el) {
        // Remove all static product-item divs
        const staticItems = this.$el.querySelectorAll('.product-item')
        staticItems.forEach(item => item.remove())
        this.staticContentCleared = true
      }

      console.log('Search results loaded:', this.products.length, 'products')
    } else {
      console.warn('No search results found in window.theme.searchResults')
    }
  },
  methods: {
    ...mapActions(useCollectionStore, [
      'setQuickViewProduct'
    ])
  }
}
</script>